import * as React from "react";

import { Admin, CustomRoutes, EditGuesser, ListGuesser, Resource, ShowGuesser } from 'react-admin';
import simpleRestProvider from 'ra-data-simple-rest';
import './App.css';
import { UserCreate, UserList, UserUpdate } from "./resources/users";
import { PositionCreate, PositionEdit, PositionHistoricalDataCreate, PositionHistoricalDataEdit, PositionHistoricalDataList, PositionHistoricalDataShow, PositionList, PositionShow } from "./resources/position";
import { EmployeeCreate, EmployeeEdit, EmployeeList, EmployeeShow } from "./resources/employee";
import { TransactionEdit, TransactionList, TransactionShow } from "./resources/transaction";
import { ReportMonthCreate, ReportMonthList, ReportMonthShow, Report_monthEdit, Report_monthEditCAdmin } from "./resources/report_month";
import { FirebaseAuthProvider } from 'react-admin-firebase';
import { CalendarDataCreate, CalendarDataEdit, CalendarDataList, CalendarDataShow } from "./resources/calendar_data";
import CustomLoginPage from './login/CustomLoginPage';
import { ReimbursableTypeCreate, ReimbursableTypeEdit, ReimbursableTypeList, ReimbursableTypeShow, ReimbursementTypeHistoricalDataList, ReimbursementTypeHistoricalDataEdit, ReimbursementTypeHistoricalDataShow, reimbursementTypeHistoricalDataCreate } from "./resources/reimbursable_type";
import { ReimbursementCreate, ReimbursementEdit, ReimbursementEditSA, ReimbursementList, ReimbursementListSA, ReimbursementShow } from "./resources/reimbursement";
import { ReimbursableReportCreate, ReimbursableReportEdit, ReimbursableReportList, ReimbursableReportShow, ReimbursableReportEditCA } from "./resources/reimbursable_report";
import { baseURL, httpClient } from "./providers/constants";
import DownloadReport from "./components/remuneration-report-download";
import { BrowserRouter, Route } from "react-router-dom";
import { ContractCreate,ContractEdit, ContractList } from "./resources/contracts";
import { DeductionsCreate,DeductionsList,DeductionsEdit, DeductionsHistoryList } from "./resources/deductions";

const firebaseConfig = {
  apiKey: "AIzaSyADapZlo9esyLXT_a2nJmywnF7dj-xSQPM",
  authDomain: "billing-c02a0.firebaseapp.com",
  projectId: "billing-c02a0",
  storageBucket: "billing-c02a0.appspot.com",
  messagingSenderId: "183687739753",
  appId: "1:183687739753:web:989e907634d838d56ba5f8"
};
const authProvider = FirebaseAuthProvider(firebaseConfig, null);
const myAuthProvider = {
  // Copy all authprovider functionality
  ...authProvider,
  // Wrap the login and check for custom claims
  login: async (params) => {
    const user = await authProvider.login(params);
    if (user.user._delegate.accessToken == null) {
      return Error("Unable to login at this time");
    }
    localStorage.setItem('access_token', user.user._delegate.accessToken);
    //   const loggedInUser = await httpClient('http://localhost:5000/logged_in_user', {});
    //   localStorage.setItem('role', loggedInUser.json.roles);
    return user;
  },
  logout: async () => {
    await authProvider.logout();
    localStorage.removeItem('access_token');
    return Promise.resolve();
  },
  // checkError: () => Promise.resolve(),
  // checkAuth: () =>
  //     localStorage.getItem('username') ? Promise.resolve() : Promise.reject(),
  getPermissions: async () => {
    const claims = await authProvider.getPermissions();
    // console.log("Permissions ");
    // console.log(claims); 
    const role = claims.role;

    return role != null ? Promise.resolve(role) : Promise.reject();
  },
  // getIdentity: () =>
  //     Promise.resolve({
  //         id: 'user',
  //         fullName: 'Jane Doe',
  //         avatar:
  //             'data:image/jpeg;base64,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',
  //     }),

};

const dataProvider = simpleRestProvider(baseURL, httpClient);

const App = () => (

  <BrowserRouter>
    <Admin dataProvider={dataProvider} authProvider={myAuthProvider} loginPage={CustomLoginPage}>
      {permissions => (
        <>
          {permissions === 'superadmin'
            ? <Resource name="users" list={UserList} create={UserCreate} edit={UserUpdate} show={ShowGuesser} />
            : null}

          <Resource name="positions"
            list={PositionList}
            create={permissions === 'superadmin' ? PositionCreate : null}
            show={PositionShow}
            edit={permissions === 'superadmin' ? PositionEdit : null} />

          <Resource name="position_historical_data"
            list={PositionHistoricalDataList}
            create={permissions === 'superadmin' ? PositionHistoricalDataCreate : null}
            edit={permissions === 'superadmin' ? PositionHistoricalDataEdit : null}
            show={PositionHistoricalDataShow} />

          <Resource name="employees"
            list={EmployeeList}
            show={EmployeeShow}
            create={permissions === 'superadmin' ? EmployeeCreate : null}
            edit={permissions === 'superadmin' ? EmployeeEdit : null} />

          <Resource name="report_months"
            list={ReportMonthList}
            show={ReportMonthShow}
            create={ReportMonthCreate}
            edit={permissions === 'superadmin' ? Report_monthEdit : Report_monthEditCAdmin}
            options={{ 'label': 'Remuneration Reports' }} />

          <Resource name="contracts"
            list={ContractList}
            show={ShowGuesser}
            create={permissions === 'superadmin' ? ContractCreate : null}
            edit={permissions === 'superadmin' ? ContractEdit : null}
            options={{ 'label': 'Contracts & Addendums' }} />

          <Resource name="deductions"
            list={DeductionsList}
            show={ShowGuesser}
            create={permissions === 'superadmin' ? DeductionsCreate : null}
            edit={permissions === 'superadmin' ? DeductionsEdit : null}
            options={{ 'label': 'Adv. Rec. & Other Ded.' }} />

          <Resource name="deductions_historical_data"
            list={DeductionsHistoryList}
            options={{ 'label': 'Adv. Rec. & Other Ded. History' }} />

          <Resource name="transactions"
            list={TransactionList}
            show={TransactionShow}
            edit={permissions === 'superadmin' ? TransactionEdit : null} />

          <Resource name="reimbursements"
            list={permissions === 'superadmin' ? ReimbursementListSA : ReimbursementList}
            show={ReimbursementShow}
            edit={permissions === 'superadmin' ? ReimbursementEditSA : ReimbursementEdit}
            create={ReimbursementCreate} />

          <Resource name="reimbursable_type"
            list={ReimbursableTypeList}
            edit={permissions === 'superadmin' ? ReimbursableTypeEdit : null}
            create={permissions === 'superadmin' ? ReimbursableTypeCreate : null}
            show={ReimbursableTypeShow} />

          <Resource name="reimbursable_historical_data"
            list={ReimbursementTypeHistoricalDataList}
            edit={permissions === 'superadmin' ? ReimbursementTypeHistoricalDataEdit : null}
            create={permissions === 'superadmin' ? reimbursementTypeHistoricalDataCreate : null}
            show={ReimbursementTypeHistoricalDataShow} />

          <Resource name="reimbursable_report"
            list={ReimbursableReportList}
            create={ReimbursableReportCreate}
            show={ReimbursableReportShow}
            edit={permissions === 'superadmin' ? ReimbursableReportEdit : ReimbursableReportEditCA} />

          <Resource name="calendar_data"
            list={CalendarDataList}
            show={CalendarDataShow}
            create={CalendarDataCreate}
            edit={CalendarDataEdit} />

          <CustomRoutes noLayout>
            <Route path="/report-download/:type/:id/:name" element={<DownloadReport />} />
          </CustomRoutes>
          {/* <Resource name="position_category" list={Position_categoryList} /> */}

        </>
      )}
    </Admin>
  </BrowserRouter>
);

export default App;